import { Component, OnDestroy, OnInit, ViewEncapsulation, ViewChild, Input } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, finalize, Observable, Subject, takeUntil } from 'rxjs';
import { IProfileDetails } from 'src/app/core/domain/profile.model';
import { RecommendedService } from 'src/app/core/service/recommended.service';
import { getProfileData } from 'src/app/core/state/profile';
import Swal from 'sweetalert2';

// import Swiper core and required modules
import SwiperCore, { Autoplay, Navigation, SwiperOptions, Virtual, Pagination } from "swiper";
import { SwiperComponent } from 'swiper/angular';

SwiperCore.use([Autoplay, Navigation, Virtual, Pagination]);
@Component({
  selector: 'app-recommended-corporates',
  templateUrl: './recommended-corporates.component.html',
  styleUrls: ['./recommended-corporates.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RecommendedCorporatesComponent implements OnInit {

  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  @Input() simpleUI = false;
  private destroyed$: Subject<void> = new Subject();
  loading = false;
  investors = []
  // chunkedInvestors = []

  profileDetails: IProfileDetails;
  public profileDetails$: Observable<IProfileDetails>;
  constructor(
    private recommendedService: RecommendedService,
    private readonly store: Store,
  ) { }

  ngOnInit(): void {
    this.loading = true
    this.getStartups();
    this.profileDetails$ = this.store.pipe(select(getProfileData));
      this.profileDetails$.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
        if (res) {
          this.profileDetails = res;
          this.getStartups();
        }
      })
  }

  onMouseenter(){
    console.log('onMouseenter', this.swiper.swiperRef)
    this.swiper.swiperRef.autoplay.stop()
  }

  onMouseleave() {
    this.swiper.swiperRef.autoplay.start()
  }
  getStartups() {
    this.recommendedService.getRecommendedCorporates().pipe(finalize(() => this.loading = false)).subscribe((res) => {
      console.log('getRecommendedMentors', res)
      if (res && res.length) {
        this.investors = res.filter((e) => e).map((e) => {
          return {
            ...e,
            user: e.user[0],
            // elevatorPitch: e.pitchDeck.elevatorPitch
          }
        })
      }
    })
  }

  hideStartup(id: string) {
    Swal.fire({
      title: 'Hide Recommendation',
      text: 'Are you sure want to remove this recommendation. The result will not appear in recommendations in future.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: 'var(--color-theme)',
      cancelButtonColor: '#7D8185',
      confirmButtonText: 'Hide'
    }).then((result) => {
      if (result.isConfirmed) {
        this.recommendedService.hideRecommendedCorporates(id).subscribe((res) => {
          if (res) {
            console.log('hideStartup');
            this.getStartups();
          }
        })
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

}
